<template lang="pug">
  router-view
</template>

<script>
export default {
  name: 'Index'
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/IssueStructure/index.vue